import { ColumnVO } from '@ag-grid-community/core';
import every from 'lodash/every';
import find from 'lodash/find';
import includes from 'lodash/includes';
import intersectionWith from 'lodash/intersectionWith';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import { ViewColumn } from 'common/types/viewColumn';

import { ERROR_COLUMN_MISMATCH } from './TableHelpers';
import { HierarchyColumnConfig } from '../vif';

// Returns a ViewColumn (if found) given a partial ag-grid ColumnVO object
export function findCorrespondingColumn(
  columns: ViewColumn[],
  columnToFind: Partial<ColumnVO>,
): ViewColumn | undefined {
  return find(columns, (c) => c.fieldName === columnToFind.id);
}

export function getColumnUpdates(allColumns: ViewColumn[], newColumns: ViewColumn[]) {
  // Get any column updates from the source:
  // Returns the columns from the source that are included in the table visualization
  const intersection = intersectionWith(allColumns, newColumns, (column, newCol) => {
    return column.fieldName === newCol.fieldName;
  });

  const updatedNewColumns = map(newColumns, (newCol) => {
    const originalColumn = intersection.find((col) => col.fieldName === newCol.fieldName)!;
    delete originalColumn.position;

    return originalColumn;
  });

  return updatedNewColumns;
}

export function isNotGeoColumn(column: any) {
  return !column.dataTypeName.match(/(location|point|polygon|line)$/i);
}

export function checkForColumnMismatch(allColumns: ViewColumn[], newColumns: ViewColumn[]) {
  if (!isEmpty(newColumns)) {
    const fieldNames = map(allColumns, 'fieldName');
    const hasValidColumns = every(newColumns, (newColumn) => {
      // Check to see if the fieldName is still in dataset columns
      return includes(fieldNames, newColumn.fieldName);
    });

    if (!hasValidColumns) {
      throw new Error(ERROR_COLUMN_MISMATCH);
    }
  }
}
